import angular from 'angular';
import ngResource from 'angular-resource';
import nwConstants from '../../nw-constants';
/**
 * nwng.resourcse
 *  - Access to data served from the matriwebng Java backend
 */
const res_module = angular.module('nwng.resources', [
    ngResource,
    nwConstants,
]);
export default res_module.name;
// UrlService palauttaa urleja ulkoisiin systeemeihin jottei tarvitse hardkoodata näitä ympäri softaa
res_module.factory('UrlService', ['Constants', '$translate', function (Constants, $translate) {
        var result = {};
        const normalizeUrl = (url) => {
            return new URL(url).href;
        };
        // Returns URL to the login page
        result.loginUrl = function () {
            const url = Constants.custUrl(`${Constants.isWebbvag ? 'loginsewinvag.php' : 'loginfi.php'}`);
            // resolve any '../' in the url
            const normalized = new URL(url).href;
            return normalized;
        };
        result.rekisteriseloste = function () {
            return Constants.apiUrl('custom/tiek/' + Constants.tiekId +
                '/gdpr/rekisteriseloste/' + Constants.lang + '/' + $translate.instant('TIEKUNNAN_REKISTERISELOSTE') + '.pdf');
        };
        result.htietosopimus = function () {
            return Constants.apiUrl('custom/tiek/' + Constants.tiekId +
                '/gdpr/sopimus/' + Constants.lang + '/sopimus.pdf');
        };
        // Valtakirja henkilötietojen käsittelystä
        result.htkvaltakirja = function (ext) {
            // Ladattavana eri tiedostomuotoja: pdf, docx
            return Constants.cdnUrl(`gdpr/${Constants.isWebbvag ? 'Fullmakt' : 'Valtakirja osakasrekisterin ylläpitoon'}.${ext}`);
        };
        result.documentSign = function (uuid, passphrase) {
            // Visma Sign. https://www.onnistuu.fi/api/docs/v1/#action-document-create-invitations
            // https://www.onnistuu.fi/<language>/invitation/<uuid>/<passphrase>/
            // Visma sign languages: fi, sv, en, nb, da
            return 'https://www.onnistuu.fi/' + (Constants.lang == 'fi-fi' ? 'fi' : 'sv') + '/invitation/' +
                uuid + '/' + passphrase;
        };
        result.mml2023book = function () {
            return 'https://www.maanmittauslaitos.fi/sites/maanmittauslaitos.fi/files/attachments/2023/12/yksityistien-tieyksikointi-2023-fi.pdf';
        };
        result.gdprAgreementUrl = function () {
            return Constants.custUrl('nwt_app.php?id=' + Constants.tiekId + '#!/gdprsopimus');
        };
        // kirjanpidon etusivu
        result.kpEtusivuUrl = function () {
            return Constants.custUrl('netwintie_kp.php?id=' + Constants.tiekId);
        };
        // tiedotteet etusivu
        result.tiedoteEtusivuUrl = function () {
            return Constants.custUrl('netwintie_tiedote.php?id=' + Constants.tiekId);
        };
        // linkki javascript applikaatioon haluttuun polkuun
        //  - tätä tarvitaan sivuilla joissa _ei_ ajeta 'uutta' applikaatiota (käytännössä kaikki vanhat sivut)
        //    mutta halutaan tehdä linkki applikaation tiettyyn paikkaan _javascriptistä_
        //  - vastaava kuin nwtng_link() php puolella
        result.nwAppUrl = function (polku) {
            return Constants.custUrl('nwt_app.php?id=' + Constants.tiekId) + '#!/' + polku;
        };
        // linkki v2 React-applikaatioon (/app/{tiekId}/...) haluttuun polkuun
        //  - sama isäntä kuin tämä sovellus, joten juuresta alkava polku riittää
        //  - vastaava kuin nwAppUrl, mutta v2-sivuille
        result.v2AppUrl = function (polku) {
            return `/app/${Constants.tiekId}/${polku}`;
        };
        // Returns URL to an invoice batch (v2 page)
        result.laskueraUrl = function (laskueraId) {
            return result.v2AppUrl(`laskuerat/${encodeURIComponent(laskueraId)}`);
        };
        // Returns URL to an invoice pdf
        result.laskuPdfUrl = function (laskuId) {
            const url = Constants.custUrl(`netwintie_lasku.php?id=${Constants.tiekId}&laskuid=${encodeURIComponent(laskuId)}`);
            return normalizeUrl(url);
        };
        // Returns URL to basic contact information of a person
        result.henkiloMuokkausUrl = function (henkiloId) {
            if (!henkiloId) {
                return undefined;
            }
            let url = '';
            if (Constants.isYhdistys) {
                url = Constants.custUrl(`koulu_jasenet.php?t=henkilomuokkaa&id=${Constants.tiekId}&henkilo=${henkiloId}`);
            }
            else {
                url = Constants.custUrl(`netwintie.php?t=henkilomuokkaa&id=${Constants.tiekId}&henkilo=${henkiloId}`);
            }
            return normalizeUrl(url);
        };
        // Returns URL to yksikkolaskelma PDF (new feature used for mml2023+)
        result.yksikkoLaskelmaPdfUrl = function (laskelmaId, lajittelu) {
            // Java Backend version
            // return Constants.apiUrl(`custom/tiek/${Constants.tiekId}/yksikointi/laskelmat/${id}/report.pdf?lang=${Constants.lang}`);
            // New version from PHP backend
            return Constants.custUrl(`yksikkolaskelma.pdf.php?tiekId=${Constants.tiekId}&laskelmaId=${laskelmaId}&lang=${Constants.lang}&lajittelu=${lajittelu}`);
        };
        result.tiedotteetPaasivu = function () {
            const url = Constants.custUrl(`netwintie_tiedote.php?id=${Constants.tiekId}`);
            return normalizeUrl(url);
        };
        return result;
    }]);
res_module.factory('Customer', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/customers/:id'), {
            id: '@id'
        }, {
            update: {
                method: 'PUT'
            }
        });
    }]);
// GeoData = API which works mostly with FeatureCollection = confusing, considered Legacy
res_module.factory('GeoData', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/:tiekId/geodata/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
// Geo = API which works mostly with Feature = new style
res_module.factory('Geo', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/:tiekId/geo/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('Ohje', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/ohje/:id'), {
            id: '@id'
        }, {
            getImageList: {
                isArray: true,
                url: Constants.apiUrl('custom/ohje/kuvalista/:variant')
            }
        });
    }]);
res_module.factory('OhjeKirja', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/ohje/book/:variant'), {});
    }]);
res_module.factory('Haara', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tie/:tiekId/haarat/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('Liittyma', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tie/:tiekId/liittymat/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('Kiinteisto', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/kiinteistot/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
// DEPRECATED: the Java invoice read endpoints (custom/tiek/:tiekId/laskut/...)
// are superseded by the PHP v2 API (/api/tiek/{tiekId}/laskut/... and
// /laskuerat/...). This resource is kept only for the legacy v1 UI; do not add
// new usages. (TieLaskuLog below is NOT deprecated — payment-log mutations have
// no PHP equivalent and remain canonical.)
res_module.factory('TieLasku', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/laskut/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        }, {
            searchByViiteNro: {
                method: "POST",
                isArray: true,
                url: Constants.apiUrl('custom/tiek/:tiekId/laskut/searchByViiteNro')
            }
        });
    }]);
res_module.factory('TieLaskuLog', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/laskut/:laskuId/log/:id'), {
            id: '@id',
            tiekId: Constants.tiekId,
            laskuId: '@laskuId'
        }, {
            searchByTunniste: {
                method: "POST",
                isArray: true,
                url: Constants.apiUrl('custom/tiek/:tiekId/laskut/log/searchByTunniste')
            },
            saveMultiple: {
                method: "POST",
                isArray: true,
                url: Constants.apiUrl('custom/tiek/:tiekId/laskut/log')
            }
        });
    }]);
res_module.factory('Tosite', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/kpito/:tiekId/tositteet/:id'), {
            id: '@id',
            tiekId: Constants.tiekId,
            lang: Constants.lang
        }, {
            saveHandle409: {
                method: 'POST',
                noIntercept: [409] // tells out httpErrorInterceptor to not show an alert for 409
            }
        });
    }]);
res_module.factory('Kirjaus', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/kpito/:tiekId/kirjaukset/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('KpTili', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/kpito/:tiekId/tilit/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('KpProjekti', ['$resource', 'Constants', function ($resource, Constants) {
        // NOTE! project does not have an id in reality, projects just exist
        // as a property of accounting entries
        return $resource(Constants.apiUrl('custom/kpito/:tiekId/projects/:id'), {
            // id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('AutoTiliApi', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/kpito/:tiekId/autotili/:path'), {
            tiekId: Constants.tiekId
        }, {
            getCfg: {
                params: { path: 'cfg' }
            },
            createM: {
                method: 'POST',
                params: { path: 'm' }
            },
            createT: {
                method: 'POST',
                params: { path: 't' }
            }
        });
    }]);
res_module.factory('Sektioner', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.slimApiUrl(`tiek/${Constants.tiekId}/sektioner/:id`), {
            id: '@id',
        });
    }]);
res_module.factory('YksikointiTyyppi', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/yksikointi/tyypit/:id'), {
            id: '@id',
            tiekId: Constants.tiekId,
            lang: Constants.lang,
        }, {
            'getLajit': {
                method: 'GET',
                isArray: true,
                url: Constants.apiUrl('custom/tiek/:tiekId/yksikointi/tyypit/:id/lajit')
            }
        });
    }]);
res_module.factory('YksikkoLaskelma', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/yksikointi/laskelmat/:id'), {
            id: '@id',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('YksikkoRaportti', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/yksikointi/laskelmat/:id/report'), {
            id: '@id',
            tiekId: Constants.tiekId,
            lang: Constants.lang,
        });
    }]);
//Andelar = (webbväg) kiinteistöjen sektiot ja niiden andelit
res_module.factory('Andelar', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/yksikointi/yksikot'), {
            tiekId: Constants.tiekId
        }, {
            saveMultiple: {
                method: "POST",
                isArray: true
            }
        });
    }]);
// Tieväli = kiinteistön tieväli ("liikennelajin instanssi")
// Parametrina usein kiinteistoId -> filtteröi kiinteistön mukaan
res_module.factory('Tievali', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/yksikointi/tievalit/:id'), {
            id: '@id',
            laskelmaId: '@laskelmaId',
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('Tiekunta', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:id'), {
            id: '@id'
        }, {
            getThis: {
                method: 'GET',
                params: { id: Constants.tiekId }
            }
        });
    }]);
res_module.factory('GdprRegisterData', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/gdpr/registerdata'), {
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('EmailErat', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/email/erat/:id'), {
            tiekId: Constants.tiekId,
            id: '@id'
        });
    }]);
res_module.factory('Emails', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/tiek/:tiekId/email/erat/:eraId/emails'), {
            tiekId: Constants.tiekId
        });
    }]);
res_module.factory('SessionData', ['$resource', 'Constants', function ($resource, Constants) {
        return $resource(Constants.apiUrl('custom/session/data/:id'), {
            id: '@id'
        }, {
            getSessionInfo: {
                method: 'GET',
                url: Constants.apiUrl('custom/session'),
            }
        });
    }]);
